module.exports = __webpack_public_path__ + "img/logo-full-colour.d4811af0.png";